<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="device">Device </label>
                  <b-form-select id="device" :plain="true" :options="deviceList" v-model="searchBy.device" text-field="label" value-field="key">
                    <template slot="first">
                      <option :value="null">-- Please select an option --</option>
                    </template>
                  </b-form-select>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="status">Status </label>
                  <b-form-select id="status" :plain="true" :options="statusOptions" v-model="searchBy.status" text-field="label" value-field="value">
                  </b-form-select>
                </b-col>
                <b-col sm="3" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="search"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-image'></i> Poster Ad List </h3>
            <b-button variant="primary" class="float-right" @click="addModal = true">Add Poster</b-button>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(sn)="data">
                {{data.index+1 + ((currentPage-1)*perPage)}}
              </template>
              <template v-slot:cell(ActionType)="data">
                <span v-if="data.item.ActionType === 0">Launch URL</span>
                <span v-if="data.item.ActionType === 1">Launch Game</span>
                <span v-if="data.item.ActionType === 2">Promotion URL</span>
                <span v-if="data.item.ActionType === 3">Launch URI</span>
              </template>
              <template v-slot:cell(Background)="data">
                <img :src="`${data.item.Background[0]}${data.item.ThumbnailCompression}`" alt="" width="250px">
              </template>
              <template v-slot:cell(Type)="data">
                <span v-if="data.item.Type===0">Web</span>
                <span v-if="data.item.Type===1">Mobile</span>
                <span v-if="data.item.Type===2">Adaptive</span>
              </template>
              <template v-slot:cell(Status)="data">
                <b-badge variant="success" v-if="data.item.Status === 1">Active</b-badge>
                <b-badge variant="danger" v-if="data.item.Status === 0">Disable</b-badge>
              </template>
              <template v-slot:cell(action)="data">
                <b-button variant="info" @click="updateModalData(data.item)"><i class="icons icon-pencil"></i></b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <AddModal :actionList="actionList" :promotionList="promotionList" :categoryList="categoryList" :deviceList="deviceList" :brandList="brandList" :showAddModal="addModal" @cancelAdd="cancelAddModal()" />
    <UpdateModal :actionList="actionList" :promotionList="promotionList" :categoryList="categoryList" :deviceList="deviceList" :brandList="brandList" :showUpdateModal="updateModal" :updateData="updateData" @cancelUpdate="closeUpdateModal()" :accountOptions="statusOptions"/>
    
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../events.js'
  import AddModal from './Poster/AddPoster'
  import UpdateModal from './Poster/UpdatePoster'
  
  export default {
    name: 'member',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        actionList: [
          { value: 4, text: 'No action' },
          { value: 0, text: 'External Link' },
          { value: 1, text: 'Launch Game' },
          { value: 2, text: 'Promotion URL' },
          { value: 3, text: 'Internal Link' }
        ],
        deviceList: [
          { key: 0, label: 'Web' },
          { key: 1, label: 'App' },
          { key: 2, label: 'Adaptive' }
        ],
        categoryList: [
          // { key: 'All', value: 'All' },
          // { key: 'Live Casino', value: 'Live Casino' },
          // { key: 'Slots', value: 'Slots' }
        ],
        promotionList: [],
        brandList: [],
        items: [],
        fields: [
          {key: 'sn', label: 'S.No'},
          {key: 'Category', label: 'Category'},
          {key: 'ActionType', label: 'ActionType'},
          {key: 'Background', label: 'Background'},
          {key: 'EnableDate', label: 'Start Time (GMT +8)'},
          {key: 'DisableDate', label: 'End Time (GMT +8)'},
          {key: 'Type', label: 'Device'},
          {key: 'Status', label: 'Status'},
          {key: 'action', label: 'Action'}
        ],
        addModal: false,
        updateModal: false,
        updateData: {},
        currentPage: 1,
        perPage: 30,
        statusOptions: [
          { value: 1, label: 'Active' },
          { value: 0, label: 'Disable' }
        ],
        searchBy: {
          device: null,
          status: 1
        }
      }
    },
    components: {
      AddModal,
      UpdateModal
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      search () {
        this.getPoster()
      },
      async getBrandList () {
        try {
          this.fetchingBrand = true
          let { data } = await this.$http.post(this.API_ENDPOINT + '/game/v2/platform/getList', { headers: { 'Content-Type': 'application/json' } })
          this.brandList = data.list
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        } finally {
          this.fetchingBrand = false
        }
      },
      async getPromotionList () {
        try {
          let { data } = await this.$http.get(this.API_ENDPOINT + '/promotion/getPromotionList', { header: { 'Content-Type': 'application/json' } })
          this.promotionList = data.list
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async getPoster () {
        try {
          let device = this.searchBy.device === null ? '' : this.searchBy.device
          let status = this.searchBy.status
          let queryStr = `status=${status}&device=${device}`
          let { data } = await this.$http.get(`${this.API_ENDPOINT}/cms/poster/getAll/?${queryStr}`, { headers: { 'Content-Type': 'application/json' } })
          this.items = data.result
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      async getCategorylist () {
        try {
          let { data } = await this.$http.get(`${this.API_ENDPOINT}/cms/poster/category/list`, { headers: { 'Content-Type': 'application/json' } })
          this.categoryList = data.data.map(function (x) { return { key: x.Name, value: x.Name } })
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        }
      },
      updateModalData (item) {
        this.updateModal = true
        this.updateData = item
      },
      closeUpdateModal () {
        this.updateModal = false
        this.updateData = {}
        this.getPoster()
      },
      cancelAddModal () {
        this.addModal = false
        this.getPoster()
      }
    },
    async created () {
      await Promise.all([
        this.getPoster(),
        this.getBrandList(),
        this.getPromotionList(),
        this.getCategorylist()
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/poster/Poster.vue